export const classTypeOptions = [
  {
    label: "Private (Indoor)",
    value: "Private (Indoor)",
  },
  {
    label: "Private (Outdoor)",
    value: "Private (Outdoor)",
  },
  {
    label: "Join (2-3pax)",
    value: "Join (2-3pax)",
  },
  {
    label: "Join (4-5pax)",
    value: "Join (4-5pax)",
  },
  {
    label: "Autism Class",
    value: "Autism Class",
  },
  {
    label: "Late Evening Class",
    value: "Late Evening Class",
  },
  {
    label: "Bad Weather conditions 50%",
    value: "Bad Weather conditions 50%",
  },
  {
    label: "Infant/Toddler",
    value: "Infant/Toddler",
  },
];
